import { Accordion, Card, Collapse, ListGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ButtonMl } from './ButtonMl';
import { Alert } from 'react-bootstrap';

export const MercadoLibre = () => {
  const { user, totalProperties, statusSinchronized } = useSelector(
    state => state.ml
  );
  return (
    <Card className="bg-white">
      <ButtonMl />

      <Collapse in={!!user}>
        <div>
          <Card.Body>
            {/* Alert user */}
            {user?.user_type !== 'real_estate_agency' &&
              user?.user_type !== undefined && (
                <Alert variant="warning">
                  <Alert.Heading>
                    Importante sobre el usuario {user?.ml_user}
                  </Alert.Heading>
                  <p>
                    Detectamos que el usuario conectado a mercadolibre no
                    corresponde a un usuario del tipo inmobiliaria. Por favor,
                    tenga en cuenta que si el sistema no encuentra ninguna
                    publicación es probable que la cuenta conectada no sea la
                    correcta.
                  </p>
                </Alert>
              )}

            <Card.Title>Información de Usuario</Card.Title>
            <ListGroup variant="flush">
              <ListGroup.Item className="d-flex justify-content-between align-items-center">
                <span>ID de Mercado Libre</span>
                <span>{user?.ml_id}</span>
              </ListGroup.Item>

              <ListGroup.Item className="d-flex justify-content-between align-items-center">
                <span>Nombre de Usuario</span>
                <span>{user?.ml_user}</span>
              </ListGroup.Item>

              <ListGroup.Item className="d-flex justify-content-between align-items-center">
                <span>Sitio</span>
                <span>{user?.ml_site}</span>
              </ListGroup.Item>

              <ListGroup.Item className="d-flex justify-content-between align-items-center">
                <span>
                  Publicaciones en Mercadolibre <b>activas</b> localizadas en
                  CABA
                </span>
                <span>{totalProperties.properties_to_import}</span>
              </ListGroup.Item>

              <ListGroup.Item className="d-flex justify-content-between align-items-center">
                <span>Publicaciones actualmente enlazadas con el portal</span>
                <span>{totalProperties.properties_imported}</span>
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>

          <Collapse
            in={
              statusSinchronized.properties_imported.count > 0 ||
              statusSinchronized.properties_with_errors.count > 0
            }
          >
            <div>
              <Card.Body>
                <Card.Title>Propiedades Sincronizadas</Card.Title>
                <ListGroup variant="flush">
                  <ListGroup.Item className="d-flex justify-content-between align-items-center">
                    <span>Publicaciones Sincronizadas Correctamente</span>
                    <span>{statusSinchronized.properties_imported.count}</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between align-items-center">
                    <span>Publicaciones Sin Sincronizar (Con Errores)</span>
                    <span>
                      {statusSinchronized.properties_with_errors.count}
                    </span>
                  </ListGroup.Item>
                  {statusSinchronized.properties_with_errors.count > 0 && (
                    <ListGroup.Item>
                      <Accordion>
                        <Accordion.Item eventKey="0" className="px-5 pe-0">
                          <Accordion.Header className="">
                            Listado de publicaciones con errores
                          </Accordion.Header>
                          <Accordion.Body className="py-0">
                            {statusSinchronized.properties_with_errors.ids.map(
                              (error, index) => (
                                <p key={index} className="my-1">
                                  <a
                                    href={error.permalink}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {error.permalink}
                                  </a>
                                  <ul>
                                    {error.cause.map((error, index) => (
                                      <li key={index}>{error}</li>
                                    ))}
                                  </ul>
                                </p>
                              )
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Card.Body>
            </div>
          </Collapse>
        </div>
      </Collapse>
    </Card>
  );
};
